import type { SVGProps } from 'react';
const SvgDehaze = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#dehaze_svg__a)">
      <path
        fill="currentColor"
        d="M2 15.5v2h20v-2H2Zm0-5v2h20v-2H2Zm0-5v2h20v-2H2Z"
      />
    </g>
    <defs>
      <clipPath id="dehaze_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDehaze;
